
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireforschooltripinpune() {



    const cardData =
    {
        keyword: 'Bus Hire for School Trips in Pune',
        heading: 'Amruta Travels: Bus Hire for School Trips in Pune',
        headingDescription: 'Amruta Travels offers Bus Hire for School Trips in Pune, ensuring a safe, comfortable, and reliable transportation solution for students and faculty. Whether it’s an educational tour, picnic, science park visit, or historical site exploration, our well-maintained buses are equipped to make the journey smooth and enjoyable. We prioritize safety with experienced drivers, GPS-enabled tracking, and regular vehicle maintenance. Choose from our fleet of 17-seater, 32-seater, and 50-seater buses to accommodate any group size. With punctual service, affordable pricing, and a strong focus on student safety, Amruta Travels makes school trips in Pune hassle-free and memorable. Book your school trip bus with us today!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



    "services": [
    {
      "name": "Bus Hire for School Trips in Hadapsar Pune",
      "description": "Amruta Travels provides dedicated bus hire services in Hadapsar Pune for school trips and educational excursions. Our buses are equipped with comfortable seating, GPS tracking, and experienced drivers trained in student safety, making them ideal for day-long and outstation school travel."
    },
    {
      "name": "Bus Hire for School Trips in Pimpri Chinchwad",
      "description": "Schools in Pimpri Chinchwad can count on Amruta Travels for secure and budget-friendly bus rentals for educational tours. We offer both AC and Non-AC buses in various seating capacities, ensuring a smooth and comfortable journey for students and staff."
    },
    {
      "name": "Bus Hire for School Picnic to Morachi Chincholi",
      "description": "Plan your school’s nature getaway to Morachi Chincholi with Amruta Travels. Our well-maintained buses provide a safe and enjoyable ride for students. With flexible timings and punctual service, we make your school picnic planning hassle-free."
    },
    {
      "name": "Bus Hire for School Picnic from Pune to Mahabaleshwar",
      "description": "Take your school group on a refreshing hill station picnic to Mahabaleshwar. Amruta Travels offers AC and Non-AC bus rentals with experienced drivers, ensuring comfort, safety, and punctuality for a memorable educational trip from Pune."
    },
    {
      "name": "Bus Hire for School Picnic from Pune to Alibaug",
      "description": "Amruta Travels provides reliable bus rental services for school groups traveling from Pune to Alibaug. Enjoy a safe and scenic ride with our GPS-enabled, comfortable buses tailored for long-distance educational and recreational trips."
    },
    {
      "name": "Bus Hire for School Picnic from Pune to Mumbai",
      "description": "Book a school picnic bus to Mumbai with Amruta Travels. We offer multiple seating options with AC and Non-AC variants, ideal for museum visits, parks, or sightseeing. Our trained drivers ensure student safety and timely arrival at each destination."
    },
    {
      "name": "Bus Hire from Pune to Water Park for School Picnic",
      "description": "Planning a fun water park picnic for students? Amruta Travels offers school bus hire services to popular water parks near Pune. With ample storage for bags, secure seating, and careful drivers, we prioritize student safety and comfort for a fun-filled day."
    },
    {
      "name": "Bus Hire from Pune to Outstation School Picnic",
      "description": "Whether it’s a heritage trip or a science center tour, Amruta Travels provides dependable bus services for outstation school picnics. Our buses are maintained to high standards with all safety protocols in place, ensuring a stress-free experience for both students and teachers."
    },
    {
      "name": "Bus Hire for School Picnic in Pimpri Chinchwad",
      "description": "Amruta Travels offers school picnic bus rental services in Pimpri Chinchwad with options ranging from 17-seaters to 50-seaters. Our fleet is designed for student comfort and includes AC and Non-AC buses ideal for both local and outstation destinations."
    }
  ],
  "tableData": [
    ["Bus Hire for School Trips in Hadapsar Pune", "Bus Hire for School Trips in Pimpri Chinchwad"],
    ["Bus Hire for School Picnic Morachi Chincholi", "Bus Hire for School Picnic Pune to Mahabaleshwar"],
    ["Bus Hire for School Picnic Pune to Alibaug", "Bus Hire for Pune to Mumbai for School Picnic"],
    ["Bus Hire for Pune to Water Park for School Picnic", "Bus Hire for Pune to Outstation School Picnic"],
    ["Bus Hire for School Picnic in Pimpri Chinchwad", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Safe and Comfortable Bus Hire for School Trips in Pune",
    "WhyChoosedescription": "Amruta Travels offers Bus Hire for School Trips in Pune, providing a safe and comfortable travel experience for students. Our buses are specifically designed to accommodate groups of children, ensuring that they travel with ample space, comfort, and safety. With spacious seating, air conditioning, and well-maintained interiors, your students can enjoy a smooth and enjoyable journey to their educational destinations, whether it's a historical site, museum, or outdoor activity."
  },
  {
    "WhyChooseheading": "Ideal for Educational Tours, Field Trips, and Extracurricular Activities",
    "WhyChoosedescription": "Our buses are the perfect choice for school educational tours, field trips, and extracurricular outings. Whether it’s a visit to a local science museum, historical monuments, or nature reserves, we offer reliable transportation that ensures students arrive safely and comfortably. Our drivers are experienced and trained in handling school trips, prioritizing student safety at all times while making the journey pleasant and enjoyable."
  },
  {
    "WhyChooseheading": "Experienced and Safety-Conscious Drivers",
    "WhyChoosedescription": "Safety is our top priority when it comes to school trips. Our drivers are highly experienced, well-trained, and understand the responsibility of transporting students. They are punctual, courteous, and maintain a safe environment throughout the trip, ensuring students and teachers have a stress-free journey. With their knowledge of local routes and traffic regulations, they ensure safe and timely travel at all times."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Schools",
    "WhyChoosedescription": "We understand that schools have budget constraints, which is why we offer affordable Bus Hire services for school trips. Amruta Travels provides transparent pricing with no hidden charges, so you can plan your trip’s expenses confidently. Whether you need a bus for a day trip or a longer journey, we provide budget-friendly options without compromising on quality or safety."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses for Maximum Comfort",
    "WhyChoosedescription": "Our buses undergo regular cleaning and maintenance to ensure they remain in top condition for every trip. We prioritize cleanliness and hygiene, especially when transporting students. From sanitized seats to well-kept interiors, we make sure the bus provides a comfortable environment throughout the journey, allowing students to relax and enjoy their trip. Additionally, our vehicles are checked regularly for safety and performance to ensure a smooth ride."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations Across Pune",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations in Pune, ensuring that we can accommodate your school’s specific needs. Whether your students are being picked up from their school, a central location, or a designated meeting point, we can adjust the pickup and drop-off locations to suit your schedule. Our flexible service makes it easier for schools to plan trips, whether it’s a short excursion or a longer journey to out-of-town locations."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for School Trips",
    "WhyChoosedescription": "Every school trip is unique, and we understand that. We offer customizable itineraries that cater to the specific needs of your school group. Whether you want to make multiple stops along the way, have a flexible departure time, or need to follow a specific route, we will work with you to create a travel plan that suits your trip’s objectives. Our goal is to make sure that your school trip is organized, fun, and enriching for all students."
  },
  {
    "WhyChooseheading": "Simple Booking Process and Dedicated Support",
    "WhyChoosedescription": "Booking a bus for school trips in Pune is simple with Amruta Travels. Our customer support team is available to assist you through the booking process, whether you prefer to book online, via phone, or in person. We ensure all your requirements are met, from selecting the right bus size to customizing the itinerary. Our dedicated team is always ready to answer any questions and ensure everything is arranged smoothly before, during, and after the trip."
  }
]


























    }

const faqData = [
  {
    question: 'How can I hire a bus for a school trip in Pune?',
    answer: 'Hiring a bus for a school trip in Pune with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll assist you in selecting the right bus based on your school’s needs and the number of students.',
  },
  {
    question: 'What types of buses are available for school trips in Pune?',
    answer: 'We offer a variety of buses for school trips in Pune, including 32, 35, 45, and 50-seater options. Our buses are equipped with comfortable seating, air conditioning, and ample space for students and their belongings.',
  },
  {
    question: 'Are the buses safe for school trips?',
    answer: 'Yes, safety is our top priority. All our buses are regularly inspected and maintained. We also provide experienced and licensed drivers who ensure safe and smooth journeys for students.',
  },
  {
    question: 'How much does it cost to hire a bus for a school trip in Pune?',
    answer: 'The cost depends on the bus size, trip duration, and distance. Please contact us with your school trip details for a customized quote based on your requirements.',
  },
  {
    question: 'Can I request a bus for a local school trip within Pune?',
    answer: 'Yes, we provide buses for local school trips within Pune, whether it’s for field trips, educational tours, or any other events. Our buses are ideal for such activities.',
  },
  {
    question: 'Do you provide luxury buses for school trips?',
    answer: 'Yes, we offer both standard and luxury buses for school trips. Our luxury buses come with additional comfort features such as premium seating and air conditioning, providing a comfortable travel experience for students and teachers.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the school trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. You can share your school’s preferred locations, and we’ll plan the best route to suit your trip schedule.',
  },
  {
    question: 'Why should I choose Amruta Travels for school trip bus hire in Pune?',
    answer: 'Amruta Travels is known for providing reliable, safe, and comfortable buses for school trips in Pune. We prioritize punctuality, safety, and student comfort, ensuring a stress-free and enjoyable experience for everyone.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Prashant Joshi',
    role: 'School Principal, Pune',
    text: 'We hired a 45-seater bus from Amruta Travels for a school field trip. The bus was spacious, clean, and well-maintained. The driver was professional, and the trip was smooth. Highly recommend their service for school outings!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshmukh',
    role: 'Teacher, Pune',
    text: 'Amruta Travels made our school trip to the museum a success. The 35-seater bus was very comfortable, and the driver ensured we had a safe and timely journey. The students were very happy with the trip. I would definitely recommend them for school trips!',
    rating: 5,
  },
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for School Trips in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-hire-for-school-trips-in-pune.jpg",
  "description": "Book buses for school trips in Pune, including picnic spots like Mahabaleshwar, Alibaug, and water parks. Choose from a variety of buses with Amruta Travels for safe and affordable school trip transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4825"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499", // Adjust the price accordingly
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-for-school-trips-in-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Bus Hire for School Trips in Pune | School Picnic Bus Rental | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book buses for school trips in Pune, including picnics to Mahabaleshwar, Alibaug, and more. Safe and affordable transportation for school excursions with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforschooltripinpune;